import React from 'react';
import { AlertAdapter, RegularButton } from 'pg-ui-library';
import {
  NewHireExceptionModalBody,
  NewHireExceptionModalForm,
  NewHireExceptionModalLabel,
} from 'src/components/new-hire-exception-modal/styles';
import { useMutation } from '@tanstack/react-query';
import NewHireExceptionService from 'src/services/new-hire-exception.service';
import { useFormik } from 'formik';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { IChangeFlag } from 'src/interfaces/IChangeFlag';
import { useTranslation } from 'react-i18next';
import { ChangeFlagRadio, SingleNewHireException } from './styles';

const NewHireChangeFlag: React.FC = () => {
  const { selectedEmployee } = useTypedSelector(state => state.employees.data);
  const { t } = useTranslation();

  const mutationCreate = useMutation(
    (variables: IChangeFlag) =>
      NewHireExceptionService.change({
        employeeId: selectedEmployee.employee?.id as unknown as '',
        isQle: variables.isQle,
        isNewHire: variables.isNewHire,
      }),
    {
      onSuccess: () => {
        AlertAdapter('Enroll section updated!', 'success');
      },
      onError: () => {
        AlertAdapter('Failed to update the enroll section', 'error');
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      employeeId: selectedEmployee.employee?.id as unknown as '',
      isQle: selectedEmployee.employee?.isQle || false,
      isNewHire: selectedEmployee.employee?.isNewHire || false,
    },
    onSubmit: async (values: IChangeFlag) => {
      mutationCreate.mutate(values);
    },
  });

  const handleChange = (event: any) => {
    const { name } = event.target;

    if (name === 'isNewHire') {
      formik.setValues({
        ...formik.values,
        isNewHire: true,
        isQle: false,
      });
    } else if (name === 'isQle') {
      formik.setValues({
        ...formik.values,
        isQle: true,
        isNewHire: false,
      });
    }
  };

  return (
    <SingleNewHireException style={{ marginTop: '0%' }}>
      <div style={{ display: 'flex' }}>
        <h4 style={{ width: '180px', marginLeft: '1%' }}>Enroll Section</h4>
        <hr style={{ border: '0.1px #4948ac solid', width: '100%', height: '0.1px', marginTop: '2.3%' }} />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <NewHireExceptionModalBody style={{ flexDirection: 'row', justifyContent: 'left' }}>
          <NewHireExceptionModalForm
            style={{ marginTop: '1%', marginRight: '2%', display: 'flex', flexDirection: 'row', width: '230px' }}
          >
            <ChangeFlagRadio
              name="isNewHire"
              type="radio"
              checked={formik.values.isNewHire}
              onChange={handleChange}
              style={{ borderRadius: '0px' }}
            />
            <NewHireExceptionModalLabel style={{ marginLeft: '10%', marginTop: '0%' }}>
              {t('benefits.header.newHire')}
            </NewHireExceptionModalLabel>
          </NewHireExceptionModalForm>

          <NewHireExceptionModalForm
            style={{ marginTop: '1%', marginRight: '2%', display: 'flex', flexDirection: 'row', width: '150px' }}
          >
            <ChangeFlagRadio
              name="isQle"
              type="radio"
              checked={formik.values.isQle}
              onChange={handleChange}
              style={{ borderRadius: '0px' }}
            />
            <NewHireExceptionModalLabel style={{ marginLeft: '10%', marginTop: '0%' }}>
              {t('benefits.header.qle')}
            </NewHireExceptionModalLabel>
          </NewHireExceptionModalForm>
          <RegularButton
            disabled={!formik.isValid || mutationCreate.isLoading}
            style={{ marginTop: '0.2%', width: '100px', marginLeft: '75%' }}
            type="submit"
          >
            {t('newhireException.modal.button')}
          </RegularButton>
        </NewHireExceptionModalBody>
        <hr style={{ border: '0.1px #4948ac solid', width: '100%', marginTop: '-2%' }} />
      </form>
    </SingleNewHireException>
  );
};
export default NewHireChangeFlag;
